export const ROOT_PATH = '/mbo-widgets' as const;
export const ERROR_PATH = '/error' as const;
